"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { signOut } from "next-auth/react";
import ProfileDropdown from "@/components/ui/ProfileDropdown";
import { useNavigation } from "@/components/providers/NavigationProvider";
import { logout } from "@/utils/auth";
import { cn } from "@/utils/cn";

interface NavbarProps {
  className?: string;
}

export function Navbar({ className }: NavbarProps) {
  const { toggleSidebar } = useNavigation();
  const router = useRouter();
  const [userName, setUserName] = useState("User");
  const [userEmail, setUserEmail] = useState("user@example.com");

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      // Get user email from localStorage
      const email = localStorage.getItem("userEmail");
      const name = localStorage.getItem("userName");

      if (email && name) {
        setUserEmail(email);
        setUserName(name);
      } else {
        // If not in localStorage, try to fetch from API using stored email
        const storedEmail = localStorage.getItem("userEmail");
        if (storedEmail) {
          try {
            const response = await fetch(`/api/users?email=${encodeURIComponent(storedEmail)}`);
            if (response.ok) {
              const data = await response.json();
              if (data.user) {
                setUserName(data.user.name);
                setUserEmail(data.user.email);
                // Update localStorage with fresh data
                localStorage.setItem("userName", data.user.name);
                localStorage.setItem("userRole", data.user.role);
              }
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
          }
        }
      }
    };

    fetchUserData();
  }, []);

  const handleLogoutClick = () => {
    logout();
    signOut({ redirect: false }).then(() => {
      router.push("/login");
      router.refresh();
    });
  };

  const handleTitleClick = () => {
    router.push("/");
  };

  return (
    <nav
      className={cn(
        "fixed top-0 left-0 right-0 z-50",
        "bg-white border-b border-gray-200",
        "px-theme-md py-theme-sm",
        className
      )}
    >
      <div className="flex items-center justify-between">
        {/* Left section: Hamburger menu and app name */}
        <div className="flex items-center gap-theme-md">
          <button
            onClick={toggleSidebar}
            className={cn(
              "p-2 rounded-theme-md",
              "transition-colors",
              "focus:outline-none focus:ring-2 focus:ring-primary-600"
            )}
            style={{ color: "#473243" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f5f2f4";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
            aria-label="Toggle sidebar"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <button
            className="text-xl font-semibold cursor-pointer hover:opacity-80 transition-opacity"
            style={{ color: "#473243" }}
            onClick={handleTitleClick}
          >
            Granny Bot
          </button>
        </div>

        {/* Right section: Profile dropdown */}
        <div>
          <ProfileDropdown
            userName={userName}
            userEmail={userEmail}
            onLogoutClick={handleLogoutClick}
          />
        </div>
      </div>
    </nav>
  );
}
